(function () {
  var SIZE = 800;
  window.__thCardCrop = window.__thCardCrop || {};
  window.__thCardBake = window.__thCardBake || {};
  window.__thCardIsBake = function (handle) {
    var bake = handle && window.__thCardBake[handle];
    return !!(bake && String(bake).indexOf(".png") !== -1);
  };

  function stripTransform(u) {
    ["width", "height", "crop", "crop_left", "crop_top", "crop_width", "crop_height", "pad_color"].forEach(function (k) {
      u.searchParams.delete(k);
    });
  }

  window.__thCardUrl = function (raw, handle, size) {
    if (!raw) return "";
    var abs = String(raw);
    if (abs.indexOf("//") === 0) abs = "https:" + abs;
    if (abs.indexOf("/api/normalize-image") !== -1) {
      try {
        var inner = new URL(abs, location.origin).searchParams.get("url");
        if (inner) abs = inner;
      } catch (e) {}
    }
    var out;
    try {
      out = new URL(abs);
    } catch (e) {
      return abs;
    }
    if (out.hostname.indexOf("cdn.shopify.com") === -1 && out.pathname.indexOf("/cdn/shop/") === -1) {
      return abs;
    }
    var dim = size || SIZE;
    stripTransform(out);
    out.searchParams.set("width", String(dim));
    return out.toString();
  };
})();
